import React from "react";
import { Rating, RatingProps } from "semantic-ui-react";
import styles from "./StarRating.module.scss";

type Props = {
  rating: number;
  size?: "mini" | "tiny" | "small" | "large" | "huge" | "massive";
  disabled?: boolean;
  onRate?: (event: React.MouseEvent<HTMLDivElement>, data: RatingProps) => void;
};

const StarRating: React.FC<Props> = ({
  rating,
  size = "huge",
  disabled = false,
  onRate,
}) => {
  return (
    <Rating
      icon="star"
      defaultRating={rating}
      maxRating={5}
      size={size}
      disabled={disabled}
      className={styles.self}
      onRate={onRate}
    />
  );
};

export default StarRating;
